import * as React from 'react';
import { BondMapperMobileContainer } from '../mobileContainer';
import { useLocalizedSanityNewsBondsByUrlIdWithoutInvalid } from '../../../../../../../../../../../../../../../../../../../../sanity';
import { useNewsBondCurrentPageHandlers } from '../../../../context';
import { NewsBondsElement } from '../../../element';

export const MobileMapper = () => {
  const {
    data,
  } = useLocalizedSanityNewsBondsByUrlIdWithoutInvalid();
  const [currentPage] = useNewsBondCurrentPageHandlers();
  if (data == null) {
    return null;
  }
  return (
    <BondMapperMobileContainer>
      {data.map((sAccId, index) => (
        <NewsBondsElement
          key={`${sAccId}`}
          sAccId={sAccId}
          transform={`translateX(${(index - currentPage) * 100}%)`}
          position="absolute"
          top={0}
          left={0}
          right={0}
        />
      ))}
    </BondMapperMobileContainer>
  );
};
